/* Época Casera — visor liviano de páginas de muestra (sin librerías).
   Cualquier botón con data-ec-visor='["url1","url2"]' y data-ec-titulo="…" lo abre.
   Swipe nativo con scroll-snap; flechas, Esc y tocar el fondo para cerrar. */
(function () {
  if (window.__ecVisor) return;
  window.__ecVisor = true;
  var css = '.ecv{position:fixed;inset:0;z-index:2147483000;background:rgba(28,16,10,.94);display:flex;flex-direction:column;color:#F5EFE6;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif}' +
    '.ecv[hidden]{display:none}' +
    '.ecv__top{display:flex;align-items:center;gap:10px;padding:10px 12px;flex:none}' +
    '.ecv__tit{flex:1;min-width:0;margin:0;font-size:15px;font-weight:800;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.ecv__n{font-size:13px;opacity:.8;flex:none}' +
    '.ecv__x{flex:none;width:44px;height:44px;border:0;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;font-size:26px;line-height:44px;cursor:pointer;padding:0}' +
    '.ecv__track{flex:1;min-height:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
    '.ecv__track::-webkit-scrollbar{display:none}' +
    '.ecv__slide{flex:0 0 100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;padding:4px 12px 12px;box-sizing:border-box}' +
    '.ecv__slide img{max-width:100%;max-height:100%;width:auto;height:auto;border-radius:6px;box-shadow:0 8px 30px rgba(0,0,0,.45);background:#FBF1E8}' +
    '.ecv__nav{position:absolute;top:50%;transform:translateY(-50%);width:44px;height:44px;border:0;border-radius:50%;background:rgba(255,255,255,.16);color:#fff;font-size:24px;cursor:pointer;display:none}' +
    '.ecv__nav--p{left:12px}.ecv__nav--s{right:12px}' +
    '.ecv__dots{display:flex;justify-content:center;gap:6px;padding:0 0 14px;flex:none}' +
    '.ecv__dots span{width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.35)}.ecv__dots span.is-on{background:#C8643C}' +
    '@media (hover:hover) and (min-width:750px){.ecv__nav{display:block}}';
  var root, track, tit, num, dots, prev, next, last, total = 0;

  function armar() {
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    root = document.createElement('div');
    root.className = 'ecv'; root.hidden = true;
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Páginas de muestra');
    root.innerHTML = '<div class="ecv__top"><p class="ecv__tit"></p><span class="ecv__n"></span><button type="button" class="ecv__x" aria-label="Cerrar">×</button></div>' +
      '<div class="ecv__track"></div><div class="ecv__dots" aria-hidden="true"></div>' +
      '<button type="button" class="ecv__nav ecv__nav--p" aria-label="Página anterior">‹</button><button type="button" class="ecv__nav ecv__nav--s" aria-label="Página siguiente">›</button>';
    document.body.appendChild(root);
    track = root.querySelector('.ecv__track'); tit = root.querySelector('.ecv__tit');
    num = root.querySelector('.ecv__n'); dots = root.querySelector('.ecv__dots');
    prev = root.querySelector('.ecv__nav--p'); next = root.querySelector('.ecv__nav--s');
    root.querySelector('.ecv__x').addEventListener('click', cerrar);
    prev.addEventListener('click', function () { ir(actual() - 1); });
    next.addEventListener('click', function () { ir(actual() + 1); });
    track.addEventListener('click', function (e) { if (e.target.tagName !== 'IMG') cerrar(); });
    track.addEventListener('scroll', marcar, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'ArrowRight') ir(actual() + 1);
      if (e.key === 'ArrowLeft') ir(actual() - 1);
    });
  }
  function actual() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
  function ir(i) { i = Math.max(0, Math.min(total - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
  function marcar() {
    var i = actual();
    num.textContent = (i + 1) + ' / ' + total;
    Array.prototype.forEach.call(dots.children, function (d, k) { d.className = k === i ? 'is-on' : ''; });
  }
  function abrir(urls, titulo, desde) {
    if (!root) armar();
    last = desde; total = urls.length;
    tit.textContent = titulo || 'Páginas de muestra';
    track.innerHTML = urls.map(function (u, k) {
      return '<div class="ecv__slide"><img src="' + u + '" alt="Página de muestra ' + (k + 1) + '" decoding="async"></div>';
    }).join('');
    dots.innerHTML = urls.map(function () { return '<span></span>'; }).join('');
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    track.scrollLeft = 0; marcar();
    root.querySelector('.ecv__x').focus();
  }
  function cerrar() {
    if (!root || root.hidden) return;
    root.hidden = true; track.innerHTML = '';
    document.documentElement.style.overflow = '';
    if (last && last.focus) last.focus();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ec-visor]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var urls = [];
    try { urls = JSON.parse(b.getAttribute('data-ec-visor')); } catch (err) { return; }
    if (urls.length) abrir(urls, b.getAttribute('data-ec-titulo'), b);
  }, true);
  window.ecVisor = { abrir: abrir, cerrar: cerrar };
})();
